<div class="select__container" [style.width.px]="width">
  <div class="select__container--label">
    <span class="select__container--label-name">{{labelName}}</span>
    <span *ngIf="required" class="select__container--label-required">{{'custom_circuit_custom_fields_required' |
      translate}}</span>
  </div>
  <mat-select [id]="id" [disabled]="disabled" [multiple]="multiple" (blur)="onBlur(this)"
    [ngClass]="{'signaturit-select-disabled': disabled && !errorValue, 'signaturit-select': !disabled, 'signaturit-select-error': showError}" placeholder="{{placeholder}}"
    [(ngModel)]="selectedValue" [style.width.px]="width" (selectionChange)="onSelectChange($event, this)" (closed)="close()">
    <input *ngIf="search" #searchInput="matInput" matInput [(ngModel)]="filterContainer" (input)="filter();"
      name="select-search" autocomplete="off" class="select__container--search">

    <ng-container *ngIf="dataKey">
      <!-- CON GRUPO -->
      <ng-container *ngIf="hasGroup">
        <mat-optgroup *ngFor="let d of data" [label]="d[dataGroupLabel]" id="groupSelect">
          <mat-option *ngFor="let i of d.items" [value]="i[dataKey]"
            (click)="onClickOption(i)">{{i[dataValue]}}</mat-option>
        </mat-optgroup>
      </ng-container>

      <!-- SIN GRUPO -->
      <ng-container *ngIf="!hasGroup">
        <div *ngFor="let d of data" [ngStyle]="hasMenu ? {'display': 'flex'} : {'display': 'contents'}">
          <mat-option [value]="d[dataKey]" [disabled]="d?.disabled || (!isRowSelected(d) && hasMenu)"
            [matTooltip]="d?.disabledTooltip || ''"
            matTooltipPosition="right"
            (click)="onClickOption(d)">{{d[dataValue]}}</mat-option>
          <button class="btn" *ngIf="hasMenu" mat-icon-button [matMenuTriggerFor]="appMenu"
            (click)="setSelectedRow(d)">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </ng-container>
    </ng-container>

    <!-- ARRAY SIMPLE -->
    <ng-container *ngIf="!dataKey">
      <div *ngFor="let d of data" [ngStyle]="hasMenu ? {'display': 'flex'} : {'display': 'contents'}">
        <mat-option [value]="d" [disabled]="(!isRowSelected(d) && hasMenu)"
          (click)="onClickOption(d)">{{d}}</mat-option>
        <button class="btn" *ngIf="hasMenu" mat-icon-button [matMenuTriggerFor]="appMenu"
          (click)="setSelectedRow(d)">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </ng-container>

    <!-- MAT MENU -->
    <mat-menu #appMenu="matMenu">
      <ng-template matMenuContent>
        <mat-radio-group class="example-radio-group" [disabled]="false" (change)="onRadioChange($event, this)">
          <mat-radio-button class="example-radio-button" *ngFor="let item of menuOptions" [checked]="radioSelected == item.value" [value]="item.value">
            {{item.label}}
          </mat-radio-button>
        </mat-radio-group>
      </ng-template>
    </mat-menu>
  </mat-select>
  <mat-error *ngIf="showError">
    {{messageError}}
  </mat-error>
</div>
